var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 4.25C1.25 3.58696 1.51339 2.95107 1.98223 2.48223C2.45107 2.01339 3.08696 1.75 3.75 1.75H4.89333C5.61 1.75 6.235 2.23833 6.40917 2.93333L7.33 6.61917C7.40462 6.9175 7.38955 7.23122 7.28667 7.52102C7.18379 7.81082 6.99769 8.06383 6.75167 8.24833L5.67417 9.05667C5.56167 9.14083 5.5375 9.26417 5.56917 9.35C6.03948 10.629 6.78216 11.7906 7.74579 12.7542C8.70941 13.7178 9.87096 14.4605 11.15 14.9308C11.2358 14.9625 11.3583 14.9383 11.4433 14.8258L12.2517 13.7483C12.4362 13.5023 12.6892 13.3162 12.979 13.2133C13.2688 13.1105 13.5825 13.0954 13.8808 13.17L17.5667 14.0908C18.2617 14.265 18.75 14.89 18.75 15.6075V16.75C18.75 17.413 18.4866 18.0489 18.0178 18.5178C17.5489 18.9866 16.913 19.25 16.25 19.25H14.375C7.12667 19.25 1.25 13.3733 1.25 6.125V4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.65b12d58103db2e9c16a8ca979ce6028.svg";
export { ForwardRef as ReactComponent };